import { Polyline, Tooltip } from "react-leaflet";

export default function TrafficMonitoringRouteLayer({ positions, color, placeId, messages }) {
  return (
    <Polyline
        key={`sample-polyline-${placeId}`}
        positions={positions}
        color={color}
        weight={4}
        className="emergency-route-blink"
    >
        <Tooltip direction="top" offset={[0, -10]} opacity={1} >
            <div>
                {messages.map((message, index) => (
                  <div key={index}>{message}</div>
                ))}
            </div>
        </Tooltip>
    </Polyline>
  )
}